export default "__VITE_ASSET__Cv$yz4N6__"